import * as Yup from "yup";

import { basicEntityFromJson, IBasicEntity } from "../../../core/models";
import { fixAmount } from "../../../core/utils";
import { calcCleanWeight, calcTotalPrice } from "../utils";

interface IProductBase {
  name: string;
  defaultWastePercent: number;
  wastePercent: number;
  dirtyWeight: number;
  price: number;
  totalPrice: number;
}

export interface IProduct extends IProductBase, IBasicEntity {
  cleanWeight: number;
}

export interface IProductForm extends IProductBase {}

const productCommonValidation = {
  name: Yup.string().required(),
  defaultWastePercent: Yup.number()
    .min(0)
    .max(99)
    .required(),
  wastePercent: Yup.number()
    .min(0)
    .max(99)
    .required(),
  dirtyWeight: Yup.number()
    .min(0)
    .required(),
  price: Yup.number()
    .min(0)
    .required(),
  totalPrice: Yup.number()
    .min(0)
    .required(),
};

export const productFormValidation = Yup.object<IProductForm>({
  ...productCommonValidation,
});

export const productEditFormValidation = Yup.object<IProductForm>({
  ...productCommonValidation,
});

export const productFromJson = (json: any): IProduct => {
  const e: IProduct = {
    ...basicEntityFromJson(json),
    name: json.name.toString(),
    defaultWastePercent: fixAmount(json.defaultWastePercent),
    wastePercent: fixAmount(json.wastePercent),
    dirtyWeight: fixAmount(json.dirtyWeight),
    cleanWeight: calcCleanWeight({ dirtyWeight: json.dirtyWeight, wastePercent: json.wastePercent }),
    price: fixAmount(json.price),
    totalPrice: calcTotalPrice({
      dirtyWeight: json.dirtyWeight,
      price: json.price,
      wastePercent: json.wastePercent,
    }),
  };

  return e;
};

export const productToJson = (form: IProductForm) => {
  return {
    name: form.name.toString(),
    defaultWastePercent: parseFloat(form.defaultWastePercent.toString()),
    wastePercent: parseFloat(form.wastePercent.toString()),
    dirtyWeight: parseFloat(form.dirtyWeight.toString()),
    price: parseFloat(form.price.toString()),
  };
};
